import { render, staticRenderFns } from "./HeaderLinks.vue?vue&type=template&id=537a9456&scoped=true"
import script from "./HeaderLinks.vue?vue&type=script&lang=js"
export * from "./HeaderLinks.vue?vue&type=script&lang=js"
import style0 from "./HeaderLinks.vue?vue&type=style&index=0&id=537a9456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a9456",
  null
  
)

export default component.exports